import React, { useState } from "react";
import { parsal_img } from "../assets/mediaCall";
import axios from "axios";
import { BASE_URL } from "../apis/apis";

const Modal = ({ closeModal, selectedService }) => {
  const [formData, setFormData] = useState({
    name: "",
    // receiverName: "",
    phone: "",
    // receiverPhone: "",
    pickupAddress: "",
    dropAddress: "",
    pickupCity: "",
    dropCity: "",
    shiftingDate: "",
    itemName: "",
    itemWeight: "",
    itemUnit: "kg",
  });

  // Map service names to service_type
  const serviceTypeMapping = {
    Trucks: 1,
    "2 Wheeler": 2,
    "Packers & Movers": 3,
    "All India Parsal": 4,
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // ✅ CASE 1: PACKERS & MOVERS
      if (selectedService === "Packers & Movers") {
        const payload = {
          name: formData.name,
          phone: formData.phone,
          pickup_address: formData.pickupAddress,
          drop_address: formData.dropAddress,
          shifting_date: formData.shiftingDate,
          type: 1,
        };

        console.log("Packers payload", payload);

        const response = await axios.post(
          `${BASE_URL}users/packers-movers`,
          payload
        );

        console.log("Packers booking success", response.data);
        alert("Packers & Movers booking created successfully!");
        closeModal();
        return;
      }
      // const service_type = serviceTypeMapping[selectedService];
      // ✅ CASE 2: Pan India Parsal
      const parsedItemWeight =
        formData.itemWeight && !isNaN(parseFloat(formData.itemWeight))
          ? parseFloat(formData.itemWeight)
          : null;

      const requestBody = {
        sender_name: formData.name,
        // receiver_name: formData.receiverName,
        sender_phone: formData.phone,
        // receiver_phone: formData.receiverPhone,
        pickup_address: formData.pickupAddress,
        drop_address: formData.dropAddress,
        pickup_city: formData.pickupCity,
        drop_city: formData.dropCity,
        item_name: formData.itemName || null,
        item_weight: parsedItemWeight || null,
        item_uom: formData.itemUnit || null,
        // service_type: service_type,
        type: 2,
        // Add any other necessary fields required by the API
      };

      console.log("handleSuubb", requestBody);

      // Send a POST request to the API to create the booking
      const response = await axios.post(
        `${BASE_URL}generic/add-pan-parsal`,
        requestBody
      ); // Adjust the API endpoint as necessary

      console.log("Booking successful", response.data);
      alert("Booking created successfully!");

      // Optionally, close the modal after successful booking
      closeModal();
    } catch (error) {
      console.error("Error creating booking", error);
      alert("Failed to create booking, please try again.");
    }
  };

  const hideItemDetails =
    selectedService === "Packers & Movers" || selectedService === "Bike Taxi";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center inter z-[60]">
      <div className="bg-white py-6 px-6 sm:px-4 rounded-lg w-full max-w-lg sm:w-[93vw]  mx-auto">
        <div className="flex justify-between">
          <div></div>
          <h4 className="text-[20px] tracking-wide mb-2 font-semibold uppercase">
            {selectedService}
          </h4>
          <button className="h-6 w-6 mt-1" onClick={closeModal}>
            <img src={parsal_img.cross} className="" />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-3.5 sm:space-y-3 xs:space-y-2.5"
        >
          {/* Sender and Receiver Info */}
          {/* <div className="grid grid-cols-2 gap-4  mb-1"> */}
          <div>
            <label className="text-[14px] text-zinc-600 block font-semibold">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-3 py-[8px] border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          <div>
            <label className="text-[14px] text-zinc-600 block font-semibold">
              Phone
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={(e) => {
                const { value } = e.target;
                if (value.length <= 10 && /^\d*$/.test(value)) {
                  handleChange(e); // Only update if length <= 10 and value is numeric
                }
              }}
              // maxLength="10"
              // pattern="\d{10}"
              required
              className="w-full px-3 py-[8px] border border-gray-300 rounded-md focus:outline-none"
            />
          </div>

          {/* Pickup Address */}
          <div>
            <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
              Pickup Address
            </label>
            <input
              type="text"
              name="pickupAddress"
              value={formData.pickupAddress}
              onChange={handleChange}
              required
              className="w-full px-3 py-[8px] border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          <div>
            <label className="text-[14px] text-zinc-600 block font-semibold ">
              Drop Address
            </label>
            <input
              type="text"
              name="dropAddress"
              value={formData.dropAddress}
              onChange={handleChange}
              required
              className="w-full px-3 py-[8px] border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          {/* Pickup Address and Pickup City */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
                Pickup City
              </label>
              <select
                name="pickupCity"
                value={formData.pickupCity}
                onChange={handleChange}
                required
                className="w-full px-3 text-[15px] font-medium py-[10.2px] border border-gray-300 rounded-md focus:outline-none"
              >
                <option value="" disabled>
                  Select Pickup City
                </option>
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Chennai">Chennai</option>
              </select>
            </div>
            <div>
              <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
                Drop City
              </label>
              <select
                name="dropCity"
                value={formData.dropCity}
                onChange={handleChange}
                required
                className="w-full px-3 text-[15px] font-medium py-[10.2px] border border-gray-300 rounded-md focus:outline-none"
              >
                <option value="" disabled>
                  Select Drop City
                </option>
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Chennai">Chennai</option>
              </select>
            </div>
          </div>

          {/* Drop Address and Drop City */}

          {/* Shifting Date or Item Details */}
          {hideItemDetails ? (
            selectedService === "Packers & Movers" ? (
              <div>
                <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
                  Shifting Date
                </label>
                <input
                  type="date"
                  name="shiftingDate"
                  value={formData.shiftingDate}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-[10.2px] border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
            ) : null
          ) : (
            <div>
              <div className="space-y-4">
                <div>
                  <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
                    Item Name
                  </label>
                  <input
                    type="text"
                    name="itemName"
                    value={formData.itemName}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-[8px] border border-gray-300 rounded-md focus:outline-none"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
                      Item Weight
                    </label>
                    <input
                      type="number"
                      name="itemWeight"
                      value={formData.itemWeight}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-[8px] border border-gray-300 rounded-md focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="text-[14px] text-zinc-600 block font-semibold mb-1">
                      Item Unit
                    </label>
                    <select
                      name="itemUnit"
                      value={formData.itemUnit}
                      onChange={handleChange}
                      className="w-full px-3 text-[15px] font-medium py-[10.2px] border border-gray-300 rounded-md focus:outline-none"
                    >
                      <option value="kg">kg</option>
                      <option value="g">grams</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="w-full py-2.5 px-4 bg-[#4F23CF] text-white rounded-md"
            >
              Book Now
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
